import $ from 'jquery'
import 'select2/dist/css/select2.css'
import 'select2'

$( document ).on('turbolinks:load', function() {
  $(document).on('select2:open', e => {
    const id = e.target.id;
    const target = document.querySelector(`[aria-controls=select2-${id}-results]`);
    target.focus();
  });

  function ts_select2_users(elem){
    elem.select2({
      ajax: {
        url: "/admin/users/user_livesearch",
        method: "GET",
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            user_name: params.term,
          };
        },
        processResults: function (data, params) {
          return {
            results: data.data
          };
        },
        cache: true
      },

      placeholder: 'Select a User',
      minimumInputLength: 1,
      templateResult: formatRepo,
      templateSelection: formatRepoSelection
    });
  }

  ts_select2_users($('.user_name_search'));

  $(document).on('click', '.add_fields', function(){
    console.log('add fields clicked')
    var elems = $(".user_name_search")
    elems.each(function(){
      if(!$(this).hasClass('select2-hidden-accessible')){
        ts_select2_users($(this));
      }
    })
  });

  var elems = $(".user_name_search")
  elems.each(function(){
    console.log("lem atr", $(this).attr("data-level"))
    ts_select2_users($(this));
  })

  function formatRepo (repo) {
    if (repo.loading) {
      return repo.text;
    }

    var $container = $(
      "<div class='select2-user clearfix'>" +
        "<div class='select2-user_name'></div>" +
      "</div>"
    );

    $container.find(".select2-user_name").text(repo.user_name);
    return $container;
  }

  function formatRepoSelection (repo) {
    console.log("repo", repo.id)
    return repo.text;
  }
});
